import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ContestList from 'components/Contest/layouts/ContestList';

import { selectCounts } from 'mt-react-common/modules/main/reducers/static/states/counts/reducer';

const NewCompetitions = props => (
  <React.Fragment>
    <h1 className="page-header hidden-xs">
      <i className="fa fa-trophy fa-lg" />
      &nbsp;Конкурсы – <strong>Новые</strong>{' '}
      <span className="badge badge-primary badge-circle text-super">
        {props.counts.started_contests.count}
      </span>
    </h1>
    <ContestList staticQueryParams={{ status: 2 }} />
  </React.Fragment>
);

NewCompetitions.propTypes = {
  // CONNECT STATES
  counts: PropTypes.shape({
    started_contests: PropTypes.shape({
      count: PropTypes.number.isRequired
    }).isRequired
  }).isRequired
};

const mapStateToProps = state => ({
  counts: selectCounts(state)
});

export default connect(mapStateToProps)(NewCompetitions);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Competitions/NewCompetitions/NewCompetitions.js